import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Alert, Card, Col, Row, Spin, Statistic, Table, Typography } from "antd";
import actions from "../../redux/admin/actions";
import { formatAdminDate } from "../../dates";
import Wrapper from "./index.style";

const { fetchDashboard } = actions;

export class DashboardPanel extends Component {
  componentDidMount() {
    this.props.fetchDashboard();
  }

  render() {
    const { t, i18n, summary, loading, error } = this.props;
    if (error) return <Alert type="error" message={error} />;
    if (loading || !summary) return <Spin />;

    const { users, organizations } = summary;
    const signupRows = Object.entries(users.signups_per_day)
      .sort(([a], [b]) => (a < b ? 1 : -1))
      .map(([day, count]) => ({ key: day, day, count }));
    const orgRows = Object.entries(organizations.by_billing_status).map(
      ([status, count]) => ({ key: status, status, count }),
    );

    return (
      <Wrapper>
        <Row gutter={[16, 16]}>
          <Col xs={12} lg={6}><Card><Statistic title={t("admin.dashboard.users")} value={users.total} /></Card></Col>
          <Col xs={12} lg={6}><Card><Statistic title={t("admin.dashboard.newUsers")} value={users.new_last_30_days} /></Card></Col>
          <Col xs={12} lg={6}><Card><Statistic title={t("admin.dashboard.organizations")} value={organizations.total} /></Card></Col>
          <Col xs={12} lg={6}><Card><Statistic title={t("admin.dashboard.disabledAccounts")} value={users.disabled} /></Card></Col>
        </Row>

        <Row gutter={[16, 16]} className="admin-section-row">
          <Col xs={24} lg={12}>
            <Card title={t("admin.dashboard.organizationsByBilling")}>
              <Table
                size="small"
                pagination={false}
                columns={[
                  {
                    title: t("admin.dashboard.billingStatus"),
                    dataIndex: "status",
                    render: (status) => t(`admin.common.statuses.${status}`),
                  },
                  { title: t("admin.dashboard.count"), dataIndex: "count", width: 120 },
                ]}
                dataSource={orgRows}
              />
              <Typography.Paragraph type="secondary" className="seat-summary">
                {t("admin.dashboard.seatsSummary", {
                  taken: organizations.seats.taken,
                  limit: organizations.seats.limit,
                })}
              </Typography.Paragraph>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card title={t("admin.dashboard.signupsPerDay")}>
              <Table
                size="small"
                pagination={{ pageSize: 8 }}
                columns={[
                  {
                    title: t("admin.dashboard.day"),
                    dataIndex: "day",
                    render: (day) => formatAdminDate(day, i18n.language),
                  },
                  { title: t("admin.dashboard.signups"), dataIndex: "count", width: 120 },
                ]}
                dataSource={signupRows}
              />
            </Card>
          </Col>
        </Row>
      </Wrapper>
    );
  }
}

DashboardPanel.propTypes = {
  summary: PropTypes.shape({
    users: PropTypes.shape({
      total: PropTypes.number.isRequired,
      new_last_30_days: PropTypes.number.isRequired,
      disabled: PropTypes.number.isRequired,
      signups_per_day: PropTypes.objectOf(PropTypes.number).isRequired,
    }).isRequired,
    organizations: PropTypes.shape({
      total: PropTypes.number.isRequired,
      by_billing_status: PropTypes.objectOf(PropTypes.number).isRequired,
      seats: PropTypes.shape({
        taken: PropTypes.number.isRequired,
        limit: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  fetchDashboard: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({ language: PropTypes.string.isRequired }).isRequired,
};

DashboardPanel.defaultProps = {
  summary: null,
  error: null,
};

const mapStateToProps = ({ Admin }) => ({
  summary: Admin.dashboard,
  loading: Admin.dashboardLoading,
  error: Admin.dashboardError,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDashboard: () => dispatch(fetchDashboard()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation("common")(DashboardPanel),
);
